import api from './apiInstance';

export { url } from './url';
export { authApi } from './auth';
export { legalPagesApi } from './legalPages';

export default api;
